<div class="datatable-container mat-elevation-z8">
  <div class="table-container table-responsive">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows style="width: 100%;">
      <!-- role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef style="max-width: 100px;"> Seu perfil no projeto </th>
        <td mat-cell *matCellDef="let element">{{element.role}}</td>
      </ng-container>

      <!-- project_title Column -->
      <ng-container matColumnDef="project_title">
        <th mat-header-cell *matHeaderCellDef> Projeto </th>
        <td mat-cell *matCellDef="let element">{{element.project_title}}</td>
      </ng-container>

      <!-- project_owner Column -->
      <ng-container matColumnDef="project_owner">
        <th mat-header-cell *matHeaderCellDef> Autor do projeto </th>
        <td mat-cell *matCellDef="let element">{{element.project_owner}}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Ações </th>
        <td mat-cell *matCellDef="let element">
          <button class="mr-2" mat-raised-button (click)="accept(element)">Aceitar</button>
          <button mat-raised-button (click)="reject(element.id)">Rejeitar</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator
    [length]="page.total"
    [pageSize]="page.page"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="page.current"
    showFirstLastButtons
    (page)="pageEvent = getInvitations($event)"
  ></mat-paginator>
</div>
